import React from 'react'
import useOpenNewTab from '../../hooks/useOpenNewTab'


function LoginAltOptions() {
    const {openTab} = useOpenNewTab()
    
    return (
        <div className="login_altOptions">
            <p className="altOptions_title">
                Don't have a product key? Having trouble?
            </p>
            <button 
                className="altOptions_btn"
                onClick={() => openTab('PURCHASE')}
            >
                Purchase A Game
            </button>
            <button
                className="altOptions_btn"
                onClick={() => openTab('CONTACT')}
            >
                Contact Us
            </button>
        </div>
    )
}

export default LoginAltOptions 